import { useState } from 'react';
import "./index.css";
import Home from './Pages/Home';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Detail from './Pages/Detail';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Tooltip } from 'reactstrap';

const App = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="body">
      <BrowserRouter>
        <div style={{ position: 'fixed', bottom: '40px', right: '20px', borderRadius: 50, cursor: 'pointer' }}>
          <a target='_blank' href='https://wa.me/971501790123'>
            <img id='whatsApp' src="/Assets/whatsapp.png" width='80px' height='80px' alt="" />
          </a>
        </div>
        <Tooltip isOpen={isOpen} placement='left' target='whatsApp' toggle={() => setIsOpen(!isOpen)}>Click Here to Chat on WhatsApp</Tooltip>
        <div className="d-flex justify-content-center align-items-center my-3">
          <img src="/Assets/2.png" height='160px' style={{ borderRadius: 50 }} />
        </div>
        <Header />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='detail/:slug' element={<Detail />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  )
};

export default App;